import {Control} from 'ol/control';
import * as Cookies from 'js-cookie'
import {changeMapType, getSavedMapLayer, mapTypeLabels, mapTypes} from "../changeType";

export class LayerControl extends Control {
    /**
     * @type {EpMap}
     */
    epMap = null;

    /**
     * @param {Object} [opt_options] Control options.
     */
    constructor(opt_options) {
        const options = opt_options || {};

        const button = document.createElement('button');
        button.type = 'button';
        button.innerHTML = '<i style="font-size: 14px" class="fas fa-layer-group"></i>';

        const element = document.createElement('div');
        element.className = 'ol-layers-picker ol-unselectable ol-control';
        element.appendChild(button);

        super({
            element: element,
            target: options.target,
        });

        this.epMap = options.epMap ?? null;

        button.addEventListener('click', this.handleOpenLayersMenu.bind(this), false);

        let that = this;
        if(this.epMap) {
            this.epMap.map.on('click', function(e) {
                let target = $(e.target);
                if(
                  !target.closest('.ol-layers-picker-dialog').length &&
                  $('.ol-layers-picker-dialog').length
                ) {
                    that.handleOpenLayersMenu()
                }
            })
        }
    }

    static getLayerSavedVisibility(id) {
        return Cookies.get(`layer-${id}`);
    }

    static setLayerSavedVisibility(id, state) {
        Cookies.set(`layer-${id}`, state)
    }

    generateMenuHTML() {
        const element = $(this.element)
        const {top, left} = element.position();
        const width = element.width();

        const layers = this.getMap().epMap.layers;

        const content = $('<div style="overflow: auto; " class="ol-control-content"></div>');
        const container = $(`<div class="ol-unselectable ol-control ol-layers-picker-dialog" style="top: ${top}px; left: ${left + width + 4}px;"></div>`)
        container.append(content)

        const select = $(`
            <select class="form-select form-select-sm mb-2" name="mapType" id="mapType">
                ${Object.keys(mapTypes).map((mapType) => `
                    <option value="${mapType}">${mapTypeLabels[mapType]}</option>
                `).join('')}
            </select>
        `)

        content.append(select);

        getSavedMapLayer(select);

        let that = this;
        select.change(function() {
            if(that.epMap) {
                changeMapType(that.epMap.getMapLayer(), $(this).val())
            }
        })

        content.append(`<span>Warstwy</span>`)

        let mapHeight = $(this.getMap().getViewport()).height();
        content.css({maxHeight: mapHeight - top - 16})

        let bdlLayerVisible = false;

        for(let layer of layers) {
            let isVisible = layer.getLayer().getVisible();
            const row = $(`<div style="display: flex; flex-direction: row; align-items: center;"></div>`)
            const input = $(`<input class="ol-layer-check" id="ol-layer-${layer.name}" ${isVisible ? 'checked' : ''} type="checkbox" name="${layer.name}" />`);

            const that = this;

            input.change(function() {
                that.handleVisibilityChange(layer);

                if(layer.name === 'bdl') {
                    that.reloadMenu();
                }
            })

            row.append(input);
            row.append(`<label style="margin-left: 4px;" for="ol-layer-${layer.name}">${layer.title}</label>`)

            content.append(row)

            if(layer.name === 'bdl' && isVisible) {
                bdlLayerVisible = true;
            }
        }

        if(bdlLayerVisible) {
            // BDL
            content.append(`<div class="mt-3"><span>Bank danych o lasach</span></div>`)

            for (let layer of LayerControl.getAvailableBdlLayersSync()) {
                let isVisible = (LayerControl.getLayerSavedVisibility(`bdl-${layer.Name}`) ?? 'false') === 'true';

                const row = $(`<div style="display: flex; flex-direction: row; align-items: center;"></div>`)
                const input = $(`<input class="ol-layer-check" id="ol-layer-bdl-${layer.Name}" ${isVisible ? 'checked' : ''} type="checkbox" name="${layer.Title}" />`);

                const that = this;

                input.change(function () {
                    that.handleBdlVisibilityChange(layer);
                })

                row.append(input);
                row.append(`<label style="margin-left: 4px;" for="ol-layer-bdl-${layer.Name}">${layer.Title}</label>`)

                content.append(row)
            }
        }

        return container;
    }

    reloadMenu() {
        let viewport = $(this.getMap().getViewport())
        const node = $('.ol-layers-picker-dialog');

        if(node.length > 0) {
            node.remove();
        }

        viewport.find('.ol-overlaycontainer-stopevent').append(this.generateMenuHTML())
    }

    handleOpenLayersMenu() {
        let viewport = $(this.getMap().getViewport())
        const node = $('.ol-layers-picker-dialog');

        if(node.length === 0) {
            viewport.find('.ol-overlaycontainer-stopevent').append(this.generateMenuHTML())
        } else {
            node.remove();
        }
    }

    handleVisibilityChange(layer, state = null) {
        let wasVisible = (LayerControl.getLayerSavedVisibility(layer.name) ?? 'true') === 'true';

        if(state === null) {
            LayerControl.setLayerSavedVisibility(layer.name, !wasVisible);
            layer.getLayer().setVisible(!layer.getLayer().getVisible())
        } else {
            LayerControl.setLayerSavedVisibility(layer.name, state);
            layer.getLayer().setVisible(state);
        }
    }

    handleBdlVisibilityChange(layer, state = null) {
        let wasVisible = (LayerControl.getLayerSavedVisibility('bdl-' + layer.Name) ?? 'false') === 'true';

        if(state === null) {
            LayerControl.setLayerSavedVisibility('bdl-' + layer.Name, !wasVisible);
        } else {
            LayerControl.setLayerSavedVisibility('bdl-' + layer.Name, state);
        }

        if(this.getMap().epMap.bdl) {
            this.getMap().epMap.bdl.reload();
        }
    }

    static getAvailableBdlLayersSync() {
        return JSON.parse(localStorage.getItem('bdl-layers') ?? '[]');
    }
}
